/**
 * use-risk-rules — 风控策略写 API（ADM-USR-S007，超管限定 · 机密）
 *
 * 本轮 MVP 仅开放两类写（契约 §②/§⑤，对应 server routes/v1/risk-rules）：
 * - PATCH /api/v1/risk-rules/:id/enabled body { enabled } 全局启停
 * - PATCH /api/v2/apps/:app_id/risk-rules/:id/enabled body { enabled } App独立启停，404不回落v1
 * - PATCH /api/v1/risk-rules/:id/threshold body { condition_value }  改已有规则阈值（仅阈值类标量）
 * 新增 / 删除 / 改条件维度 / 运算符 / 动作 / 名称端点不存在（UI 按 NOT-in-scope 禁用）。
 * 响应返更新后整行 RiskRuleResponse，调用方据此 toast 服务端真值并 invalidate ['risk-rules']。
 */

import type {
  RiskRuleResponse,
  RiskRuleV1Response,
  UpdateRiskRuleThresholdRequest,
} from '@novel-admin/shared';
import { apiRequest } from '~/api/client';

export const riskRulesApi = {
  /** PATCH /api/v1/risk-rules/:id/enabled — 超管启停 toggle */
  setEnabled: (id: string, enabled: boolean, appId?: string) =>
    apiRequest<RiskRuleResponse | RiskRuleV1Response>({
      method: 'PATCH',
      // App只能使用独立v2路径，旧API404不重试v1，防未知字段被strip后变成全局写。
      path: appId
        ? `/api/v2/apps/${appId}/risk-rules/${id}/enabled`
        : `/api/v1/risk-rules/${id}/enabled`,
      body: { enabled },
    }),
  /** PATCH /api/v1/risk-rules/:id/threshold — 改阈值（仅阈值类标量 condition_value，非阈值维度服务端拒绝） */
  setThreshold: (id: string, body: UpdateRiskRuleThresholdRequest) =>
    apiRequest<RiskRuleV1Response>({
      method: 'PATCH',
      path: `/api/v1/risk-rules/${id}/threshold`,
      body,
    }),
};
